import { render, staticRenderFns } from "./StoredImagesContainer.vue?vue&type=template&id=d0cfeff0&"
import script from "./StoredImagesContainer.vue?vue&type=script&lang=js&"
export * from "./StoredImagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports